import Api from './Indicadores'
export default {
    getUserData(){
        return Api().get("/user/data");
    },
    getUsersByCompany(id){
        return Api().get("/user/company/"+id)
    },
    getUsersByCompanyAll(id){
        return Api().get("/user/company-all/"+id)
    },
    getQueryName(query){
        return Api().get("/user/query/name/"+query)
    },
    createUser(data){
        return Api().post("/user/createInCompany",data)
    },

    getUserCompanyQuery(userId, companyId){
        return Api().get("/buscar/user/"+userId+ "/company/"+companyId)
    },
    
    deleteUserCompany(userCompanyId){
        return Api().delete("/user/deleteInCompany/"+userCompanyId)
    },
    updateUserLite(user){
        return Api().post("/user/data/update-lite", user);
    },
    updatePassword(user){
        return Api().post("/user/data/update-pass", user);
    },
    getBySector(sectorId){
        return Api().get('/user/sector/'+sectorId);
    },

    sectorDelete(sectorId){
        return Api().delete("/user-sector/"+sectorId)
    },
    sectorInsert(userId, sectorId, leadershipId){
        return Api().post("/user-sector/"+userId+"/"+sectorId)
    },
    getUsername(id){
        return Api().get("/user/data/username/"+id);
    },
    findByReference(ref){
        return Api().get('user/buscar/'+ref)
    },
    findByUsername(ref){
        return Api().get('user/buscar/username/'+ref)
    },
    linkUser(user, company){
        return Api().post('user/company/'+{user} + '/' + company)
    }
}